import React, {FC} from 'react';
import Box from '@material-ui/core/Box';
import {ActivationsColorPalette} from '../../../../../constants/fortnite-games/ColorSwatch';

export interface ColorSwatchDotProps {
    height: string;
    width: string;
    colorIndex: number;
    cssClass?: string;
}

const ColorSwatchDot: FC<ColorSwatchDotProps> = ({
    cssClass,
    height,
    width,
    colorIndex
}: ColorSwatchDotProps) => {
    return (
        <Box
            className={cssClass}
            style={{
                backgroundColor: `${ActivationsColorPalette[colorIndex]}`,
                width,
                height,
                borderRadius: '50%'
            }}
        />
    );
};

export default ColorSwatchDot;
